<!--
 * @Descripttion: 
 * @version: 
 * @Author: alex.yang
 * @Date: 2022-08-02 17:49:31
 * @LastEditors: alex.yang
 * @LastEditTime: 2022-08-03 14:48:47
-->
<template>
    <div class="followRecords">
        <commonSelect
            @changeDate="changeDate"
            @clickTagDate="clickTagDate"
        ></commonSelect>
        <div class="table-wrap" >
            <div class="title-wrap">
                <div class="tw-content">
                    <div class="search-wrap">
                        <el-input clearable v-model="keyword" placeholder="请输入搜索内容"></el-input>
                        <el-button @click="clickSearch" type="primary">搜索</el-button>
                    </div>
                </div>
                <el-button type="primary" @click="isCreateRecord = true">创建记录</el-button>
            </div>
            <el-table :data="tableData" height="580" border style="width: 100%" v-loading="loading">
            <el-table-column align="center" prop="id" label="ID" width="100"></el-table-column>
            <el-table-column align="center" prop="system_admin.nickname" label="客服负责人" width="100"></el-table-column>
            <el-table-column align="center" prop="contact" label="联系方法">
                <template slot-scope="scope">
                    <div v-if="scope.row.contact == 1">手机</div>
                    <div v-if="scope.row.contact == 2">微信</div>
                </template>
            </el-table-column>
            <el-table-column align="center" prop="title" label="标题" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column align="center" prop="content" label="内容" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column align="center" prop="create_timex" label="填写时间" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column align="center" prop="create_timex" label="操作" width="100" fixed="right">
                <template slot-scope="scope">
                <div class="operation-wrap">
                    <el-tooltip class="item" effect="dark" content="编辑" placement="top">
                        <i @click="clickEdit(scope.row)" class="iconfont el-icon-edit"></i>
                    </el-tooltip>
                    <el-tooltip class="item" effect="dark" content="删除" placement="top">
                        <i @click="clickDel(scope.row)" class="iconfont el-icon-delete"></i>
                    </el-tooltip>
                </div>
                </template>
            </el-table-column>
            </el-table>
            <div class="pagination-wrap">
            <el-pagination
                @current-change="handleCurrentChange"
                :current-page.sync="currentPage"
                :page-size="10"
                layout="total, prev, pager, next"
                :total="total">
            </el-pagination>
            </div>
        </div>
        <el-dialog title="创建跟进记录" 
            :visible.sync="isCreateRecord" 
            :before-close="handleClose"
            custom-class="dialog-wrap"
            :close-on-click-modal="false">
            <div class="content" v-loading="isShow">
                <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
                    <el-form-item label="标题" prop="title">
                        <el-input v-model="ruleForm.title"></el-input>
                    </el-form-item>
                    <el-form-item label="内容" prop="content">
                        <el-input type="textarea" v-model="ruleForm.content"></el-input>
                    </el-form-item>
                    <el-form-item label="手机/微信号" prop="contact">
                        <el-select v-model="ruleForm.contact" placeholder="请选择联系方式">
                            <el-option
                                v-for="item in contactOptions"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
                <div class="btn-wrap">
                    <el-button v-if="editId<0" :loading="btnLoading" @click="submitForm" type="primary">创 建</el-button>
                    <el-button v-else :loading="btnLoading" @click="submitFormEdit" type="primary">编 辑</el-button>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import commonSelect from "@/components/commonSelect.vue"
import common from "@/utils/common.js"
export default {
    components:{
        commonSelect
    },
    data () {
        return {
            userInfo: {},
            tableData: [],
            loading: false,
            keyword: '',
            userId: '',
            dateType: '',
            startDate: '',
            endDate: '',
            currentPage: 1,
            total: 0,
            isCreateRecord: false,
            isShow: false,
            editId: -1,
            ruleForm: {
                title: '',
                content: '',
                contact: '',
            },
            rules: {
                title: [
                    { required: true, message: '请输入标题', trigger: 'blur' },
                ],
                content: [
                    { required: true, message: '请输入内容', trigger: 'blur' },
                ],
            },
            contactOptions: [{
                value: 1,
                label: '手机'
            },{
                value: 2,
                label: '微信'
            }],
            btnLoading: false
        }
    },
    mounted () {
        this.userInfo = JSON.parse(localStorage.getItem('userInfo'));
        this.userId = JSON.parse(localStorage.getItem('account')).id;
        this.getIndexList()
    },
    methods: {
        // 确定创建
        submitForm(){
            this.$refs.ruleForm.validate((valid) => {
                if (valid) {
                    let params = {
                        user_id: this.userId,
                        title: this.ruleForm.title,
                        content: this.ruleForm.content,
                        contact: this.ruleForm.contact,
                    }
                    this.btnLoading = true;
                    common.connect("/customerservicev1/user_follow/store",params,(res)=>{
                        if(res.isSuccess == 1){
                            this.$message({
                                message: res.msg,
                                type: 'success'
                            });
                            this.getIndexList();
                            this.isCreateRecord = false;
                            this.$refs.ruleForm.resetFields();
                        }
                        this.btnLoading = false;
                    });
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        // 关闭弹窗
        handleClose(){
            this.isCreateRecord = false;
            this.editId = -1;
            this.$refs.ruleForm.resetFields();
        },
        // 删除
        clickDel(row){
            this.$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                common.connect("/customerservicev1/user_follow/delete",{id: row.id},(res)=>{
                    this.$message({
                        message: res.msg,
                        type: 'success'
                    });
                    this.getIndexList();
                });
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });          
            });
        },
        // 确定编辑
        submitFormEdit(){
            this.$refs.ruleForm.validate((valid) => {
                if (valid) {
                    let params = {
                        id: this.editId,
                        user_id: this.userId,
                        title: this.ruleForm.title,
                        content: this.ruleForm.content,
                        contact: this.ruleForm.contact,
                    }
                    this.btnLoading = true;
                    common.connect("/customerservicev1/user_follow/update",params,(res)=>{
                        if(res.isSuccess == 1){
                            this.$message({
                                message: res.msg,
                                type: 'success'
                            });
                            this.getIndexList();
                            this.btnLoading = false;
                            this.isCreateRecord = false;
                            this.editId = -1;
                            this.ruleForm.title = '';
                            this.ruleForm.content = '';
                            this.ruleForm.contact = '';
                        }
                        this.btnLoading = false;
                    });
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        // 编辑页
        clickEdit(row){
            this.editId = row.id;
            common.connect("/customerservicev1/user_follow/edit",{id: row.id},(res)=>{
                this.isCreateRecord = true;
                this.userId = res.data.user_id;
                this.ruleForm.title = res.data.title;
                this.ruleForm.content = res.data.content;
                this.ruleForm.contact = res.data.contact;
            });
        },
        // 日期选择
        changeDate(startDate,endDate){
            this.currentPage = 1;
            this.startDate = startDate.slice(0,11)+' 00:00:01';
            this.endDate = endDate.slice(0,11)+' 23:59:59';
            this.getIndexList()
        },
        clickTagDate(item){
            this.dateType = item.label;
            this.currentPage = 1;
            if(item.label != 'date'){
                this.startDate = '';
                this.endDate = '';
                this.getIndexList();
            }
        },
        // 搜索
        clickSearch(){
            this.currentPage = 1;
            this.getIndexList()
        },
        // 获取列表数据
        getIndexList(){
            let params = {
                user_id: this.userId,
                keyword: this.keyword,
                date_type: this.dateType,
                start_date: this.startDate,
                end_date: this.endDate,
                page: this.currentPage
            }
            this.loading = true;
            common.connect("/customerservicev1/user_follow/index",params,(res)=>{
                this.total = res.data.count;
                this.tableData = res.data.list;
                this.loading = false;
            });
        },
        handleCurrentChange(val) {
            this.currentPage = val;
            this.getIndexList();
        }
    },
}
</script>

<style lang='scss'>
.followRecords{
    padding: 20px 20px 5px 20px;
    background: #fff;
    .table-wrap{
        padding-top: 10PX;
        .title-wrap{
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding-bottom: 10px;
            .tw-content{
                display: flex;
                align-items: center;
            }
            .select-wrap{
                margin-right: 20px;
            }
            .search-wrap{
                display: flex;
                flex-wrap: wrap;
                align-items: center;
                .el-input{
                    width: 200px;
                    margin-right: 10px;
                }
            }
        }
    }
    .operation-wrap{
        .iconfont{
            font-size: 16px;
            padding: 0 10px;
            cursor: pointer;
        }
    }
    .pagination-wrap{
        display: flex;
        justify-content: flex-end;
        align-items: center;
        padding-top: 5px;
    }
    .dialog-wrap{
        width: 800px;
        .content{
            margin-left: 20px;
            padding: 30px 0;
            .el-input{
                width: 650px;
            }
            .el-textarea{
                width: 650px;
            }
        }
        .btn-wrap{
            display: flex;
            justify-content: center;
        }
    }
    .el-dialog{
        margin: 0;
        margin-top: 0vh !important;
        top: 50%;
        left: 50%;
        transform: translate(-50%,-50%);
        padding-bottom: 10px;
    }
}
</style>
